import { Step_Up_Transformers } from "gql/api";

export function computeUpTransLabel(
  transformer?: Partial<Step_Up_Transformers> | null
): string {
  if (transformer) {
    return `${transformer.manufacturer} ${transformer.part_number}, ${transformer.kva} KVA, ${transformer.min_secondary_voltage} V - ${transformer.max_secondary_voltage} V`;
  }
  return "";
}
